import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function Problem() {
  const problems = ['Abrumado por herramientas y consejos contradictorios', 'Cansado de perder tiempo en videos que obtienen 12 vistas', 'Frustrado porque la IA parece ayudar a todos menos a ti', 'Atascado preguntándote qué tipo de video realmente funciona', 'Agotado de aparecer en cámara o editar cada día'];
  return <section className="w-full px-4 py-16 md:py-20 bg-slate-900/50" data-id="element-239">
      <div className="max-w-4xl mx-auto" data-id="element-240">
        <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-6 leading-tight" data-id="element-241">
          Seamos honestos — Ya intentaste crear videos antes
        </h2>
        <p className="text-base md:text-xl text-gray-300 text-center mb-6" data-id="element-242">
          Quizás pasaste horas aprendiendo software, escribiendo guiones
          incómodos o grabando tomas que nunca se sintieron "lo suficientemente
          buenas".
        </p>
        <p className="text-base md:text-xl text-gray-300 text-center mb-10" data-id="element-243">
          Mientras tanto, otros publican un video generado por IA y…{' '}
          <span className="text-purple-400 font-semibold" data-id="element-244">
            ¡100,000+ vistas!
          </span>
        </p>
        <p className="text-base md:text-xl text-gray-300 text-center mb-10" data-id="element-245">
          Ventas llegando. Nuevos seguidores. Mientras tú aún estás editando.
        </p>
        <div className="bg-slate-800/50 border border-red-500/30 rounded-2xl p-6 md:p-8 mb-6" data-id="element-246">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-6" data-id="element-247">
            Y puede que hoy te sientas:
          </h3>
          <div className="space-y-4" data-id="element-248">
            {problems.map((problem, index) => <div key={index} className="flex items-start gap-3" data-id="element-249">
                <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-250" />
                <p className="text-base md:text-lg text-gray-300" data-id="element-251">{problem}</p>
              </div>)}
          </div>
        </div>
        <div className="bg-gradient-to-r from-red-500/20 to-orange-500/20 border border-red-500/30 rounded-2xl p-6 md:p-8 text-center" data-id="element-252">
          <p className="text-xl md:text-2xl font-bold text-white mb-4" data-id="element-253">
            Y lo peor…
          </p>
          <p className="text-base md:text-xl text-gray-300" data-id="element-254">
            Cada día que no publicas, alguien más sí lo hace — usando las mismas
            herramientas que tú ya podrías estar usando.
          </p>
        </div>
      </div>
    </section>;
}